module.exports = __webpack_public_path__ + "static/media/coding.5800c8fd.gif";